const managePartnershipTranslation = {
  en_US: {
    managePartnership: {
      //"account_info": 'Account Information',
      profile: "Account Profile",
      //"contacts": 'Company Contacts',
      //"profile_info": 'Profile Information',
      //-"apply_or_renew": 'Apply or renew for Specializations',
      // not there (One Primary and one Secondary contact required)
      //edit contact
      table: {
        action: "Action",
        last_name: "Last Name",
        first_name: "First Name",
        main_contact_type: "MAIN CONTACT TYPE",
        job_role: "JOB ROLE",
        email: "EMAIL",
        status: "STATUS",

        contact_type: "CONTACT TYPE",
        contact_name: "CONTACT NAME",
      },

      button: {
        edit_profile: "Edit profile",
        add_contact: "Add Contact",
        reassign: "Reassign primary contact",
      },

      labels: {
        full_comp_name: "Full company name",
        trading_name: "Trading name",
        company_type: "Company Type *",
        biz_reg_number: "Business Registration Number",
        street: "Street *",
        state: "State/Province *",
        country: "Country *",
        city: "City *",
        postal_code: "Postal Code *",
        year_established: "Year Established *",
        trading_name: "Trading Name",
        distributor: "Preferred Distributor",
        primary_phone: "Primary Phone *",
        primary_fax: "Primary fax",
        sec_website: "Secondary Website",
        //-"url": 'Website URL *',
        prefix: "Prefix",
        title: "Suffix/Title",
        first_name: "First Name *",
        last_name: "Last Name *",
        pref_language: "Preferred Language *",
        phone_number: "Phone Number *",
        //-"email_address": 'E-mail Address *',
        job_role: "Job Role *",
        contact_type: "Contact Type(select all that apply) *",
        //-"additional_contact_type": 'Additional contact type',
        list_in_partner_finder: "List in Partner Finder?",
        phone: "Phone *",
        email: "Email",
        type: "Type",
        membership_id: "Membership ID",
        parent_memb_id: "Parent membership ID",
        partner_level: "Partner Level",
        //-"additional_licenses": 'Number of additional licenses',
        start_date: "Contract start date",
        end_date: "Contract end date",
        main_contact_type: "Main contact type",
        active: "Active",
      },
      PP_APC_Header_Label: "Adobe Partner Connection Portal",
      OnbrdContactPrefLang: "Preferred Language *",
      PP_Adobe_Portal: "Adobe Partners",
      ConsolePartnerHeader: "Partnership Console",
      //-"OnbrdGenReturnToPartnerHome": "Home Page",
      ConsolePartnerContactInfoHeader: "Company Information",
      ConsolePartnerAccountCompName: "Full Company Name",
      ConsolePartnerConMainType: "Main Contact Type",
      OnbrdContactPrimaryType: "Primary",
      OnbrdContactSecondaryType: "Secondary",
      OnbrdContactOtherType: "Other",
      ConsolePartnerConActive: "Active",
      ConsolePartnerConPrefix: "Prefix",
      ConsolePartnerConSuffix: "Suffix/Title",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      ConsolePartnerConFName: "Firstname",
      ConsolePartnerConLName: "Lastnam",
      ConsolePartnerConPhone: "Phone *",
      ConsolePartnerConRole: "Job Role *",
      ConsolePartnerConEmail: "Email *",
      ConsolePartnerConLang: "Preferred Language *",
      ConsolePartnerContactAddRole: "Additional Role *",
      ConsolePartnerContactCert: "Certification",
      ConsolePartnerBtnEdit: "Edit",
      OnbrdContactPriConHeader: "Primary Contact",
      OnbrdContactSecConHeader: "Secondary Contact",
      OnbrdContactOther: "Other Contacts",
      OnbrdContactPrefix: "Prefix",
      OnbrdContactTitle: "Suffix/Title",
      OnbrdContactFName: "First Name *",
      //"OnbrdGenInputErrorMsg": "Please enter a value.",
      OnbrdContactLName: "Last Name *",
      OnbrdContactPhone: "Phone",
      OnbrdContactJRole: "Job Role *",
      OnbrdContactEmail: "Email *",
      ConsolePartnerContactCType: "Main Contact Type *",
      OnbrdContactDeactivateHelp:
        "Checking the Deactivate box will remove this contact from the account. This contact will no longer have access to Adobe systems.",
      OnbrdContactAddtlType: "Type",
      TrngSaveClose: "Save and Close",
      TrngClose: "Close",
      OnbrdGenInvalidTokenErrMsg:
        "Your link is already expired. Please call help desk.",
      //"OnbrdGenInvalidToken": "  \n<p>Invalid Transaction Token.</p>\n     ",
      OnbrdGenSessionExpired:
        "  Your session has expired. Please click on the Reassign Primary Contact button again.     ",
      OnbrdThankYouHelpDesk:
        "If you need assistance, please contact the Adobe Partner Connection Help Desk. \n<b>Email:</b> \nUS and Canada naresellers@adobe.com;Europe, Middle East and Africa euroresellers@adobe.com; Asia Pacific apacresellers@adobe.com; Latin America latamresellers@adobe.com\n<p/>\n<b>Telephone:</b> \nUS and Canada: \n408-916-9527 or 800-685-3510 \n<p/>\nEurope, Middle East and Africa: \nAll countries +44 (0)20 7365 0734; UK toll free number: 0800 783 6954; France toll free number: 0805 540 199; Germany toll free number: 0800 664 7893 \n<p/>\nAsia Pacific Region: \nAustralia: 1800615210; New Zealand; 800521499; India: 0008004401752; Indonesia: 001803447405; Philippines: 180014410441; \nThailand: 0018004418847; Malaysia: 1-300-80-0028; Singapore: 8004481641; Hong Kong: 30714923; Taiwan: 0800666536; Rest of Asia Pacific: +65 66221458 \n<p/>\nLatin America: \n1 408 916 9610",
      ConsolePartnerBtnEditProfile: "Edit Profile",
      ConsolePartnerRegistrationHeader: "Registration Information",
      ConsolePartnerMembershipId: "Membership ID",
      ConsolePartnerParentMemId: "Parent Membership ID",
      ConsolePartnerAccountStartDate: "Contract Start Date",
      ConsolePartnerAccountLevel: "Partner Level",
      ConsolePartnerAccountEndDate: "Contract End Date",
      ConsolePartnerAccountSpec: "Specialisation",
      ConsolePartnerAccountManager: "Account Manager",
      ConsolePartnerAccountLicReq: "# Additional Licenses",
      ConsolePartnerAccountHeader: "Account Profile",
      ConsolePartnerAccountCType: "Company Type *",
      ConsolePartnerAccountTradingName: "Trading Name",
      ConsolePartnerAccountRegNum: "Registration Number",
      ConsolePartnerAccountYOI: "Year Established *",
      //"ConsolePartnerAccountEmail": "Email Domain",
      ConsolePartnerAccountStreet: "Street *",
      ConsolePartnerAccountPhone: "Primary Phone *",
      ConsolePartnerAccountCity: "City *",
      ConsolePartnerAccountFax: "Primary Fax",
      ConsolePartnerAccountState: "State/Province *",
      ConsolePartnerAccountEmailAdd: "Email Address *",
      ConsolePartnerAccountCountry: "Country *",
      ConsolePartnerAccountWeb: "Website *",
      ConsolePartnerAccountPostal: "Postal Code *",
      ConsolePartnerAccountWeb2: "Secondary Website",
      OnbrdProfilePreferredDistributor: "Preferred Distributor",
      ConsolePartnerListPFinder: "List in Partner Finder?",
      ConsolePartnerAccountBRN: "Business Registration Number",
      //"OnbrdGenEmailFormatErrMsg": "Invalid email format.",
      //"OnbrdGenCorpEmailMsg": "Corporate Email Required.",
      ConsolePartnerAccountListPartnerFinder: "List in Partner Finder?",
      ConsolePartnerContactHeader: "Contacts",
      ConsolePartnerBtnAddContact: "Add Contact",
      ConsolePartnerReassignBtnLabel: "Reassign Primary Contact",
      ConsolePartnerContactAction: "ACTION",
      ConsolePartnerContactLName: "LASTNAME",
      ConsolePartnerContactFName: "FIRSTNAME",
      ConsolePartnerContactJob: "JOB ROLE",
      ConsolePartnerContactEmail: "EMAIL",
      ConsolePartnerContactStatus: "STATUS",
      ConsolePartnerBtnFirst: "First Page",
      ConsolePartnerBtnPrev: "Previous",
      ConsolePartnerBtnNext: "Next",
      ConsolePartnerBtnLast: "Last Page",
      ConsolePartnerPageSize: "Page Size",
      ConsolePartnerConReinvite: "Reinvite",
      ConsolePartnerSplznLinkHeader: "Apply/Renew Specialization",
      ReAssignSectionHeader: "Reassign Primary Contact",
      ReAssignInstructionLabel:
        'To reassign the Primary Contact:\n Change the "Contact Type" for your contacts.\n \n\nIf a contact is not listed, then he/she has not accepted the invitation to join your account.',
      //Modify Sales Centre Access if needed by checking the box next to the contact. You may only assign access to the same number of contacts who currently have access today. Therefore, the number of contacts with a check for \"Current Sales Centre Access\" must be equal to the number of contacts with \"Desired Sales Centre Access\".
      //"ReAssignDeactivateLabel": "Deactivate?",
      ReAssignMainContactTypeLabel: "Contact Type",
      ReAssignContactNameLabel: "Contact Name",
      ReAssignEmailAddLabel: "Email Address *",
      ReAssignLicenseCurrentLabel: "Current Sales Centre Access",
      ReAssignLicenseRequestedLabel: "Desired Sales Centre Access",
      ReAssignCancelBtnLabel: "Cancel",
      ReAssignConfirmBtnLabel: "Confirm",
      ConsolePartnerInvalidPageSize: "Enter a valid Page Size (1-99).",

      //new trans
      go_to_home_page: "Go back to homepage",
      restrictedSanctionBannerMessage:
        "Due to increasing sanctions restrictions, Adobe is no longer able to accept orders from partners located in Russia and Belarus. As a result, your Adobe Partner Connection (APC) programme membership will remain active until your current term ends, after which it will expire and will not be renewed. Thank you for your partnership.",

      //combining 2 words
      page_heading_other: "EDIT PROFILE",
      page_heading_prim: "EDIT PROFILE",

      // not there
      msg_reassign_popup: "One Primary and one Secondary contact required",
      profile_info: "Profile Information",

      ReAssignPrimaryContactExceedErrMsg:
        "Only one Primary Contact is allowed.",
      ReAssignSecondaryContactExceedErrMsg:
        "Only one Secondary Contact is allowed.",
      ReAssignPrimaryContactRequiredErrMsg: "A Primary Contact is required.",
      ReAssignSecondaryContactRequiredErrMsg:
        "A Secondary Contact is required.",
    },
  },
  pt_BR: {},

  zh_CN: {
    managePartnership: {
      PP_APC_Header_Label: "APC门户网站",
      OnbrdContactPrefLang: "首选语言 *",
      PP_Adobe_Portal: "Adobe合作伙伴",
      ConsolePartnerHeader: "合作关系管理平台",
      OnbrdGenReturnToPartnerHome: "返回合作伙伴主页",
      ConsolePartnerContactInfoHeader: "联系信息",
      ConsolePartnerAccountCompName: "公司全称",
      ConsolePartnerConMainType: "主要联系方式",
      OnbrdContactPrimaryType: "第一",
      OnbrdContactSecondaryType: "第二",
      OnbrdContactOtherType: "其它",
      ConsolePartnerConActive: "活跃",
      ConsolePartnerConPrefix: "前缀",
      ConsolePartnerConSuffix: "后缀/职称",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      ConsolePartnerConFName: "名字",
      ConsolePartnerConLName: "姓氏",
      ConsolePartnerConPhone: "电话 *",
      ConsolePartnerConRole: "工作角色 *",
      ConsolePartnerConEmail: "电子邮件 *",
      ConsolePartnerConLang: "首选语言 *",
      ConsolePartnerContactAddRole: "其他角色 *",
      ConsolePartnerContactCert: "认证",
      ConsolePartnerBtnEdit: "编辑",
      OnbrdContactPriConHeader: "第一联系人",
      OnbrdContactSecConHeader: "第二联系人",
      OnbrdContactOther: "其他联系人",
      OnbrdContactPrefix: "前缀",
      OnbrdContactTitle: "后缀/职称",
      OnbrdContactFName: "名字 *",
      OnbrdGenInputErrorMsg: "请输入值。",
      OnbrdContactLName: "姓氏 *",
      OnbrdContactPhone: "电话 *",
      OnbrdContactJRole: "工作角色 *",
      OnbrdContactEmail: "电子邮件 *",
      ConsolePartnerContactCType: "主要联系方式 *",
      OnbrdContactDeactivateHelp:
        "勾选“取消激活”框将从帐户中删除此联系人。此联系人将不再享有Adobe系统的访问权。",
      OnbrdContactAddtlType: "类型 *",
      TrngSaveClose: "保存并关闭",
      TrngClose: "关闭",
      OnbrdGenInvalidTokenErrMsg: "您的链接已过期。请致电服务台。",
      OnbrdGenInvalidToken: "  \n<p>交易令牌无效。</p>\n     ",
      OnbrdGenSessionExpired:
        "  您的会话已过期。请再次点击“重新分配第一联系人”按钮。     ",
      OnbrdThankYouHelpDesk:
        "如需帮助，请联系APC服务台。   \n<b>电子邮件：</b>apacresellers@adobe.com  \n<b> \n中国移动/联通：10800 744 0440   \n中国电信/网通（固话）：10800 440 0423  \n国际（其他亚太区域）: +65 66221458  \n</b>",
      ConsolePartnerBtnEditProfile: "编辑资料",
      ConsolePartnerRegistrationHeader: "注册信息",
      ConsolePartnerMembershipId: "会员ID",
      ConsolePartnerParentMemId: "父会员ID",
      ConsolePartnerAccountStartDate: "合同起始日期",
      ConsolePartnerAccountLevel: "合作伙伴级别",
      ConsolePartnerAccountEndDate: "合同终止日期",
      ConsolePartnerAccountSpec: "专业化认证",
      ConsolePartnerAccountManager: "客户经理",
      ConsolePartnerAccountLicReq: "# 其他许可证",
      ConsolePartnerAccountHeader: "帐户资料",
      ConsolePartnerAccountCType: "公司类型",
      ConsolePartnerAccountTradingName: "中文公司名称",
      ConsolePartnerAccountRegNum: "注册号码",
      ConsolePartnerAccountYOI: "成立年份 *",
      ConsolePartnerAccountEmail: "电子邮件网络域名",
      ConsolePartnerAccountStreet: "街道 *",
      ConsolePartnerAccountPhone: "首选电话 *",
      ConsolePartnerAccountCity: "城市 *",
      ConsolePartnerAccountFax: "首选传真",
      ConsolePartnerAccountState: "州/省 *",
      ConsolePartnerAccountEmailAdd: "电子邮件地址 *",
      ConsolePartnerAccountCountry: "国家/地区 *",
      ConsolePartnerAccountWeb: "网站 *",
      ConsolePartnerAccountPostal: "邮政编码 *",
      ConsolePartnerAccountWeb2: "二级网站",
      OnbrdProfilePreferredDistributor: "首选经销商",
      ConsolePartnerListPFinder: "在合作伙伴查找器中列出？",
      ConsolePartnerAccountBRN: "商业注册号码",
      OnbrdGenEmailFormatErrMsg: "电子邮件格式无效。",
      OnbrdGenCorpEmailMsg: "必须填入公司电子邮件。",
      ConsolePartnerAccountListPartnerFinder: "在合作伙伴查找器中列出(?)",
      ConsolePartnerContactHeader: "联系人",
      ConsolePartnerBtnAddContact: "添加联系人",
      ConsolePartnerReassignBtnLabel: "重新分配第一联系人",
      ConsolePartnerContactAction: "行动",
      ConsolePartnerContactLName: "姓氏",
      ConsolePartnerContactFName: "名字",
      ConsolePartnerContactJob: "工作角色",
      ConsolePartnerContactEmail: "电子邮件",
      ConsolePartnerContactStatus: "状态",
      ConsolePartnerBtnFirst: "第一页",
      ConsolePartnerBtnPrev: "上一页",
      ConsolePartnerBtnNext: "下一页",
      ConsolePartnerBtnLast: "最后一页",
      ConsolePartnerPageSize: "页面大小",
      ConsolePartnerConReinvite: "再次邀请",
      ConsolePartnerSplznLinkHeader: "申请/续订专业化认证",
      ReAssignSectionHeader: "重新分配第一联系人",
      ReAssignInstructionLabel:
        "重新分配第一联系人：\n更改联系人的“联系方式”。\n \n如果联系人不在列表中，则表示其没有接受您的帐户加入邀请。",
      //\n必要情况下，请勾选联系人旁边的框，修改销售中心访问权限。您也许仅能为目前具有访问权限的相同数量的联系人分配权限。因此，选中“现有销售中心访问权限”的联系人数量必须与选中“期望销售中心访问权限”的联系人数量一致。
      ReAssignDeactivateLabel: "取消激活？",
      ReAssignMainContactTypeLabel: "联系方式",
      ReAssignContactNameLabel: "联系人姓名",
      ReAssignEmailAddLabel: "电子邮件地址",
      ReAssignLicenseCurrentLabel: "现有销售中心访问权限",
      ReAssignLicenseRequestedLabel: "期望销售中心访问权限",
      ReAssignCancelBtnLabel: "取消",
      ReAssignConfirmBtnLabel: "确认",
      ConsolePartnerInvalidPageSize: "输入有效的页面大小（1-99）。",

      //new trans
      go_to_home_page: "返回主页",

      //combining 2 words
      page_heading_other: "编辑资料",
      page_heading_prim: "编辑资料",

      // not there
      msg_reassign_popup: "One Primary and one Secondary contact required",
      profile_info: "Profile Information",

      ReAssignPrimaryContactExceedErrMsg: "只允许有一个第一联系人。",
      ReAssignSecondaryContactExceedErrMsg: "只允许有一个第二联系人。",
      ReAssignPrimaryContactRequiredErrMsg: "必须填入第一联系人。",
      ReAssignSecondaryContactRequiredErrMsg: "必须入填入第二联系人。",
    },
  },

  de_DE: {
    managePartnership: {
      PP_APC_Header_Label: null,
      OnbrdContactPrefLang: "Bevorzugte Sprache *",
      PP_Adobe_Portal: null,
      ConsolePartnerHeader: "Konsole für Partnerschaft",
      OnbrdGenReturnToPartnerHome: "Zurück zur Partner-Homepage",
      ConsolePartnerContactInfoHeader: "Kontaktinformationen",
      ConsolePartnerAccountCompName: "Vollständiger Name des Unternehmens",
      ConsolePartnerConMainType: "Haupt-Ansprechpartnerart",
      OnbrdContactPrimaryType: "Hauptansprechpartner",
      OnbrdContactSecondaryType: "Zweiter Ansprechpartner",
      OnbrdContactOtherType: "Andere",
      ConsolePartnerConActive: "Gültig",
      ConsolePartnerConPrefix: "Titel",
      ConsolePartnerConSuffix: "Namenszusatz",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      ConsolePartnerConFName: "Vorname",
      ConsolePartnerConLName: "Nachname",
      ConsolePartnerConPhone: "Telefon *",
      ConsolePartnerConRole: "Berufliche Tätigkeit *",
      ConsolePartnerConEmail: "E-Mail *",
      ConsolePartnerConLang: "Bevorzugte Sprache *",
      ConsolePartnerContactAddRole: "Weitere Rolle *",
      ConsolePartnerContactCert: "Zertifizierung",
      ConsolePartnerBtnEdit: "Bearbeiten",
      OnbrdContactPriConHeader: "Hauptansprechpartner",
      OnbrdContactSecConHeader: "Zweiter Ansprechpartner",
      OnbrdContactOther: "Weitere Ansprechpartner",
      OnbrdContactPrefix: "Titel",
      OnbrdContactTitle: "Namenszusatz",
      OnbrdContactFName: "Vorname *",
      OnbrdGenInputErrorMsg: "Geben Sie einen Wert ein.",
      OnbrdContactLName: "Nachname *",
      OnbrdContactPhone: "Telefon *",
      OnbrdContactJRole: "Berufliche Tätigkeit *",
      OnbrdContactEmail: "E-Mail *",
      ConsolePartnerContactCType: "Haupt-Ansprechpartnerart *",
      OnbrdContactDeactivateHelp:
        "Wenn Sie „Deaktivieren“ auswählen, wird der Ansprechpartner gelöscht und hat keinen Zugang mehr zu den Systemen von Adobe.",
      OnbrdContactAddtlType: "Funktion *",
      TrngSaveClose: "Speichern und schließen",
      TrngClose: "Schließen",
      OnbrdGenInvalidTokenErrMsg:
        "Ihr Link ist bereits abgelaufen. Bitte wenden Sie sich an den Kundendienst.",
      OnbrdGenInvalidToken: "  \n<p>Ungültiges Transaktions-Token</p>\n     ",
      OnbrdGenSessionExpired: null,
      OnbrdThankYouHelpDesk:
        "<strong>Falls Sie Fragen zum Reseller-Programm oder zum Anmeldeprozess haben, wenden Sie sich bitte an den Adobe-Partner Connection Helpdesk.</strong> \nTelefonnummer (für alle EMEA-Länder): +44 (0)20 7365 0734 \nGebührenfreie Telefonnummer für Deutschland: 0800 664 7893\n   ",
      ConsolePartnerBtnEditProfile: "Profil bearbeiten",
      ConsolePartnerRegistrationHeader: "Registrierungsinformationen",
      ConsolePartnerMembershipId: "Mitgliedsnummer",
      ConsolePartnerParentMemId: "Mitgliedsnummer des Hauptunternehmens",
      ConsolePartnerAccountStartDate: "Vertragsbeginn",
      ConsolePartnerAccountLevel: "Partnerstufe",
      ConsolePartnerAccountEndDate: "Vertragsende",
      ConsolePartnerAccountSpec:
        "Informationen zum Ansprechpartner für Spezialgebiet",
      ConsolePartnerAccountManager: "Account-Manager",
      ConsolePartnerAccountLicReq: "Anzahl weiterer Lizenzen",
      ConsolePartnerAccountHeader: "Kontoprofil",
      ConsolePartnerAccountCType: "Art des Unternehmens",
      ConsolePartnerAccountTradingName: "Handelsname",
      ConsolePartnerAccountRegNum: "Registrierungsnummer",
      ConsolePartnerAccountYOI: "Gründungsjahr *",
      ConsolePartnerAccountEmail: "E-Mail-Domäne",
      ConsolePartnerAccountStreet: "Straße und Hausnummer *",
      ConsolePartnerAccountPhone: "Telefon *",
      ConsolePartnerAccountCity: "Ort *",
      ConsolePartnerAccountFax: "Fax",
      ConsolePartnerAccountState: "Bundesland *",
      ConsolePartnerAccountEmailAdd: "E-Mail *",
      ConsolePartnerAccountCountry: "Land *",
      ConsolePartnerAccountWeb: "Website *",
      ConsolePartnerAccountPostal: "PLZ *",
      ConsolePartnerAccountWeb2: "Alternative URL",
      OnbrdProfilePreferredDistributor: "Bevorzugter Distributor",
      ConsolePartnerListPFinder: null,
      ConsolePartnerAccountBRN: "Handelsregisternummer",
      OnbrdGenEmailFormatErrMsg: "Ungültiges E-Mail-Format.",
      OnbrdGenCorpEmailMsg:
        "Bitte geben Sie eine geschäftliche E-Mail-Adresse an.",
      ConsolePartnerAccountListPartnerFinder: "Eintrag im Reseller Finder (?)",
      ConsolePartnerContactHeader: "Ansprechpartner",
      ConsolePartnerBtnAddContact: "Ansprechpartner hinzufügen",
      ConsolePartnerReassignBtnLabel: "Haupt-Ansprechpartner ändern",
      ConsolePartnerContactAction: "Maßnahme erforderlich",
      ConsolePartnerContactLName: "Nachname",
      ConsolePartnerContactFName: "Vorname",
      ConsolePartnerContactJob: "Berufliche Tätigkeit",
      ConsolePartnerContactEmail: "E-Mail",
      ConsolePartnerContactStatus: "Status",
      ConsolePartnerBtnFirst: "Erste Seite",
      ConsolePartnerBtnPrev: "Zurück",
      ConsolePartnerBtnNext: "Weiter",
      ConsolePartnerBtnLast: "Letzte Seite",
      ConsolePartnerPageSize: "Seitengröße",
      ConsolePartnerConReinvite: "Erneut benachrichtigen",
      ConsolePartnerSplznLinkHeader: "Bewerben Verlängern / Spezialisierung",
      ReAssignSectionHeader: "Hauptansprechpartner neu zuweisen",
      ReAssignInstructionLabel:
        "So weisen Sie den Hauptansprechpartner neu zu: \nÄndern Sie die Ansprechpartnerart für Ihre Ansprechpartner.\n  \nWenn ein Ansprechpartner nicht aufgelistet ist, hat er/sie die Einladung zur Teilnahme nicht akzeptiert.",
      //  \n2. Ändern Sie bei Bedarf die Einstellungen für den Zugang zum Sales Centre, indem Sie das Kontrollkästchen neben dem Ansprechpartner aktivieren bzw. deaktivieren. Der Zugang kann nur für die gleiche Anzahl von Ansprechpartnern aktiviert werden, die zum gegenwärtigen Zeitpunkt Zugang hat. Daher muss die Anzahl der Ansprechpartner, für die „Zugang zum Sales Centre“ aktiviert ist, mit der Anzahl der Ansprechpartner übereinstimmen, für die „Zugang zum Sales Centre erwünscht“ aktiviert ist.
      ReAssignDeactivateLabel: "Wirklich deaktivieren?",
      ReAssignMainContactTypeLabel: "Art des Ansprechpartners",
      ReAssignContactNameLabel: "Name des Ansprechpartners",
      ReAssignEmailAddLabel: "E-Mail",
      ReAssignLicenseCurrentLabel: "Zugang zum Sales Centre",
      ReAssignLicenseRequestedLabel: "Zugang zum Sales Centre erwünscht",
      ReAssignCancelBtnLabel: "Abbrechen",
      ReAssignConfirmBtnLabel: "Bestätigen",
      ConsolePartnerInvalidPageSize:
        "Geben Sie eine gültige Seitengröße ein (1–99).",

      //new trans
      go_to_home_page: "Zurück zur Homepage",

      //combining 2 words
      page_heading_other: "PROFIL BEARBEITEN",
      page_heading_prim: "PROFIL BEARBEITEN",

      // not there
      msg_reassign_popup: "One Primary and one Secondary contact required",
      profile_info: "Profile Information",

      ReAssignPrimaryContactExceedErrMsg:
        "Nur ein Hauptansprechpartner ist zulässig.",
      ReAssignSecondaryContactExceedErrMsg:
        "Nur ein zweiter Ansprechpartner ist zulässig.",
      ReAssignPrimaryContactRequiredErrMsg:
        "Ein Hauptansprechpartner ist erforderlich.",
      ReAssignSecondaryContactRequiredErrMsg:
        "Ein zweiter Ansprechpartner ist erforderlich.",
    },
  },
  it_IT: {
    managePartnership: {
      PP_APC_Header_Label: null,
      OnbrdContactPrefLang: "Lingua preferita *",
      PP_Adobe_Portal: null,
      ConsolePartnerHeader: "Console di collaborazione",
      OnbrdGenReturnToPartnerHome: "Torna alla pagina iniziale per partner",
      ConsolePartnerContactInfoHeader: "Informazioni del contatto",
      ConsolePartnerAccountCompName: "Nome completo dell’azienda",
      ConsolePartnerConMainType: "Tipo di contatto principale",
      OnbrdContactPrimaryType: "Principale",
      OnbrdContactSecondaryType: "Secondario",
      OnbrdContactOtherType: "Altro",
      ConsolePartnerConActive: "Attivo",
      ConsolePartnerConPrefix: "Appellativo",
      ConsolePartnerConSuffix: "Titolo",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      ConsolePartnerConFName: "Nome",
      ConsolePartnerConLName: "Cognome",
      ConsolePartnerConPhone: "Telefono *",
      ConsolePartnerConRole: "Posizione *",
      ConsolePartnerConEmail: "E-mail *",
      ConsolePartnerConLang: "Lingua preferita *",
      ConsolePartnerContactAddRole: "Ruolo aggiuntivo *",
      ConsolePartnerContactCert: "Certificazioni",
      ConsolePartnerBtnEdit: "Modifica",
      OnbrdContactPriConHeader: "Contatto Principale",
      OnbrdContactSecConHeader: "Contatto Secondario",
      OnbrdContactOther: "Altri contatti",
      OnbrdContactPrefix: "Appellativo",
      OnbrdContactTitle: "Titolo",
      OnbrdContactFName: "Nome *",
      OnbrdGenInputErrorMsg: "Immettere un valore.",
      OnbrdContactLName: "Cognome *",
      OnbrdContactPhone: "Telefono *",
      OnbrdContactJRole: "Posizione *",
      OnbrdContactEmail: "E-mail *",
      ConsolePartnerContactCType: "Tipo di contatto principale *",
      OnbrdContactDeactivateHelp:
        "Se viene selezionata la casella di disattivazione, il contatto viene rimosso dall'account e non avrà più accesso ai sistemi Adobe.",
      OnbrdContactAddtlType: "Tipo *",
      TrngSaveClose: "Salva e chiudi",
      TrngClose: "Chiudi",
      OnbrdGenInvalidTokenErrMsg:
        "Il collegamento è già scaduto. Contattare l'help desk.",
      OnbrdGenInvalidToken: "  \n<p>Token transazione non valido.</p>\n     ",
      OnbrdGenSessionExpired: null,
      OnbrdThankYouHelpDesk:
        "<strong>Per eventuali domande sull’Adobe Partner Connection Reseller Program o sulla domanda presentata, contattare l’Adobe Partner Connection Help Desk:</strong> \nE-mail: euroresellers@adobe.com \nTel. (da tutti i paesi dell'area EMEA): +44 (0)20 7365 0734 \n   ",
      ConsolePartnerBtnEditProfile: "Modifica profilo",
      ConsolePartnerRegistrationHeader: "Informazioni di registrazione",
      ConsolePartnerMembershipId: "Aggiorna ID iscrizione account",
      ConsolePartnerParentMemId: "ID di iscrizione principale",
      ConsolePartnerAccountStartDate: "Data di inizio contratto",
      ConsolePartnerAccountLevel: "Livello partner",
      ConsolePartnerAccountEndDate: "Data di fine contratto",
      ConsolePartnerAccountSpec: "Informazioni sullo specialista",
      ConsolePartnerAccountManager: "Responsabile clienti",
      ConsolePartnerAccountLicReq: "# di licenze supplementari",
      ConsolePartnerAccountHeader: "Profilo account",
      ConsolePartnerAccountCType: "Tipo Azienda in English",
      ConsolePartnerAccountTradingName: "Nome commerciale",
      ConsolePartnerAccountRegNum: "Numero di registrazione",
      ConsolePartnerAccountYOI: "Anno di costituzione *",
      ConsolePartnerAccountEmail: "Dominio dell’e-mail",
      ConsolePartnerAccountStreet: "Via *",
      ConsolePartnerAccountPhone: "Num. Telefono Principale *",
      ConsolePartnerAccountCity: "Località *",
      ConsolePartnerAccountFax: "Num. Fax Principale",
      ConsolePartnerAccountState: "Provincia *",
      ConsolePartnerAccountEmailAdd: "E-mail *",
      ConsolePartnerAccountCountry: "Paese *",
      ConsolePartnerAccountWeb: "Sito web *",
      ConsolePartnerAccountPostal: "CAP *",
      ConsolePartnerAccountWeb2: "Sito web secondario",
      OnbrdProfilePreferredDistributor: "Distributore Preferito",
      ConsolePartnerListPFinder: null,
      ConsolePartnerAccountBRN: "Partita IVA",
      OnbrdGenEmailFormatErrMsg: "Formato e-mail non valido.",
      OnbrdGenCorpEmailMsg: "È necessario inserire l'e-mail aziendale.",
      ConsolePartnerAccountListPartnerFinder:
        "Elenco in sistema di rilevamento rivenditore (?)",
      ConsolePartnerContactHeader: "Contatti",
      ConsolePartnerBtnAddContact: "Aggiungi contatto",
      ConsolePartnerReassignBtnLabel: "Riattribuire contatto principale",
      ConsolePartnerContactAction: "Azione",
      ConsolePartnerContactLName: "Cognome",
      ConsolePartnerContactFName: "Nome",
      ConsolePartnerContactJob: "Posizione",
      ConsolePartnerContactEmail: "E-mail",
      ConsolePartnerContactStatus: "Stato",
      ConsolePartnerBtnFirst: "Prima pagina",
      ConsolePartnerBtnPrev: "Indietro",
      ConsolePartnerBtnNext: "Avanti",
      ConsolePartnerBtnLast: "Ultima pagina",
      ConsolePartnerPageSize: "Formato pagina",
      ConsolePartnerConReinvite: "Ripeti invito",
      ConsolePartnerSplznLinkHeader: "Applicare / Rinnova specializzazione",
      ReAssignSectionHeader: "Riassegna contatto principale",
      ReAssignInstructionLabel:
        "Per riassegnare il contatto principale:\n Modificare il tipo di contatto per i propri contatti.\n  \nSe un contatto non è elencato, significa che non ha accettato l'invito ad entrare nell'account dell'utente.",
      //  \n2. Se necessario, modificare l'accesso al Sales Centre facendo clic sulla casella di controllo accanto al contatto. È possibile assegnare l'accesso solo allo stesso numero di contatti che ne dispongono attualmente. Pertanto il numero di contatti con un segno di spunta accanto a \"Accesso corrente al Sales Centre\" deve essere uguale al numero di contatti con \"Accesso desiderato al Sales Centre\".
      ReAssignDeactivateLabel: "Disattivare?",
      ReAssignMainContactTypeLabel: "Tipo di contatto",
      ReAssignContactNameLabel: "Nome contatto",
      ReAssignEmailAddLabel: "Indirizzo e-mail",
      ReAssignLicenseCurrentLabel: "Accesso corrente al Sales Centre",
      ReAssignLicenseRequestedLabel: "Accesso desiderato al Sales Centre",
      ReAssignCancelBtnLabel: "Annulla",
      ReAssignConfirmBtnLabel: "Conferma",
      ConsolePartnerInvalidPageSize:
        "Immettere un formato pagina valido (1-99).",

      //new trans
      go_to_home_page: "Torna alla homepage",

      //combining 2 words
      page_heading_other: "MODIFICA PROFILO",
      page_heading_prim: "MODIFICA PROFILO",

      // not there
      msg_reassign_popup: "One Primary and one Secondary contact required",
      profile_info: "Profile Information",

      ReAssignPrimaryContactExceedErrMsg:
        "È consentito solo un contatto principale.",
      ReAssignSecondaryContactExceedErrMsg:
        "È consentito solo un contatto secondario.",
      ReAssignPrimaryContactRequiredErrMsg:
        "È necessario un contatto principale.",
      ReAssignSecondaryContactRequiredErrMsg:
        "È necessario un contatto secondario.",
    },
  },
  ja_JP: {
    managePartnership: {
      PP_APC_Header_Label: null,
      OnbrdContactPrefLang: "優先される言語 *",
      PP_Adobe_Portal: null,
      ConsolePartnerHeader: "パートナーシップ　コンソール",
      OnbrdGenReturnToPartnerHome: "パートナーのホームページに戻る",
      ConsolePartnerContactInfoHeader: "担当者情報",
      ConsolePartnerAccountCompName: "会社の正式名称",
      ConsolePartnerConMainType: "主担当者タイプ",
      OnbrdContactPrimaryType: "第一",
      OnbrdContactSecondaryType: "第二",
      OnbrdContactOtherType: "その他",
      ConsolePartnerConActive: "有効",
      ConsolePartnerConPrefix: "プレフィックス",
      ConsolePartnerConSuffix: "サフィックス/見出し",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      ConsolePartnerConFName: "氏名（名）",
      ConsolePartnerConLName: "氏名（氏）",
      ConsolePartnerConPhone: "電話 *",
      ConsolePartnerConRole: "職種 *",
      ConsolePartnerConEmail: "Eメール *",
      ConsolePartnerConLang: "優先される言語 *",
      ConsolePartnerContactAddRole: "付加的な役割 *",
      ConsolePartnerContactCert: "Certification",
      ConsolePartnerBtnEdit: "編集",
      OnbrdContactPriConHeader: "プライマリ（第一）担当者",
      OnbrdContactSecConHeader: "セカンダリ（第二）",
      OnbrdContactOther: "他の担当者",
      OnbrdContactPrefix: "部署名",
      OnbrdContactTitle: "役職",
      OnbrdContactFName: "名 (英語) *",
      OnbrdGenInputErrorMsg: "値を入力してください。",
      OnbrdContactLName: "姓（英語）*",
      OnbrdContactPhone: "電話（半角）*",
      OnbrdContactJRole: "職種 *",
      OnbrdContactEmail: "メール *",
      ConsolePartnerContactCType: "主担当者タイプ *",
      OnbrdContactDeactivateHelp:
        "「無効化」ボックスにチェックを入れると、担当者がアカウントから削除されます。 この担当者は、アドビ　システムにアクセスできなくなります。",
      OnbrdContactAddtlType: "タイプ *",
      TrngSaveClose: "保存して閉じる",
      TrngClose: "閉じる",
      OnbrdGenInvalidTokenErrMsg:
        "リンクの期限が切れています。 ヘルプデスクまでご連絡ください。",
      OnbrdGenInvalidToken: "  \n<p>取扱いコードが無効です。</p>\n     ",
      OnbrdGenSessionExpired: null,
      OnbrdThankYouHelpDesk:
        "ご質問がある場合、パートナーヘルプデスクまでご連絡ください。 \n<p/> \n電話: 0570-000-358  \n電話受付時間: 平日 9:30-17:30  \n電子メール: adobeinfo@adobe.com ",
      ConsolePartnerBtnEditProfile: "プロフィールを編集",
      ConsolePartnerRegistrationHeader: "登録情報",
      ConsolePartnerMembershipId: "メンバーシップID",
      ConsolePartnerParentMemId: "親メンバーシップID",
      ConsolePartnerAccountStartDate: "契約開始日",
      ConsolePartnerAccountLevel: "パートナー　レベル",
      ConsolePartnerAccountEndDate: "契約の終了日",
      ConsolePartnerAccountSpec: "専門分野",
      ConsolePartnerAccountManager: "アカウントマネージャー",
      ConsolePartnerAccountLicReq: "＃追加ライセンス",
      ConsolePartnerAccountHeader: "アカウントのプロフィール",
      ConsolePartnerAccountCType: "会社の種類",
      ConsolePartnerAccountTradingName: "商号",
      ConsolePartnerAccountRegNum: "登録番号",
      ConsolePartnerAccountYOI: "開設された年 *",
      ConsolePartnerAccountEmail: "Eメールのドメイン",
      ConsolePartnerAccountStreet: "番地 *",
      ConsolePartnerAccountPhone: "代表電場番号 *",
      ConsolePartnerAccountCity: "市町村 *",
      ConsolePartnerAccountFax: "代表ファックス番号",
      ConsolePartnerAccountState: "都道府県 *",
      ConsolePartnerAccountEmailAdd: "Eメールアドレス *",
      ConsolePartnerAccountCountry: "国 *",
      ConsolePartnerAccountWeb: "ウェブサイト *",
      ConsolePartnerAccountPostal: "郵便番号 *",
      ConsolePartnerAccountWeb2: "派生的なウェブサイト",
      OnbrdProfilePreferredDistributor: "発注先パートナー（英語/半角英数字）",
      ConsolePartnerListPFinder: null,
      ConsolePartnerAccountBRN: "法人番号",
      OnbrdGenEmailFormatErrMsg: "Eメールの形式が無効です。",
      OnbrdGenCorpEmailMsg: "会社のEメールが必要です。",
      ConsolePartnerAccountListPartnerFinder:
        "パートナーファインダーに掲載しますか（？）",
      ConsolePartnerContactHeader: "担当者",
      ConsolePartnerBtnAddContact: "担当者を追加",
      ConsolePartnerReassignBtnLabel: "プライマリ（第一）担当者の変更",
      ConsolePartnerContactAction: "アクション",
      ConsolePartnerContactLName: "氏名（氏）",
      ConsolePartnerContactFName: "氏名（名）",
      ConsolePartnerContactJob: "職種",
      ConsolePartnerContactEmail: "Eメール",
      ConsolePartnerContactStatus: "状況",
      ConsolePartnerBtnFirst: "最初のページ",
      ConsolePartnerBtnPrev: "前のページ",
      ConsolePartnerBtnNext: "次へ",
      ConsolePartnerBtnLast: "最後のページ",
      ConsolePartnerPageSize: "ページサイズ",
      ConsolePartnerConReinvite: "再び招待する",
      ConsolePartnerSplznLinkHeader: "専門リニュー/適用",
      ReAssignSectionHeader: "プライマリコンタクト（主担当者）を割り当てる",
      ReAssignInstructionLabel:
        "説明：プライマリ（第一）担当者の権利を割り当てる新しい担当者の横に表示されている担当者タイプの中から、プライマリ（第一）担当者を選択してください。なお、プライマリ（第一）担当者とセカンダリ（第二）担当者は、1つのアカウントに1人ずつしか割り当てることができません。",
      ReAssignDeactivateLabel: "無効にしますか？",
      ReAssignMainContactTypeLabel: "担当者タイプ",
      ReAssignContactNameLabel: "担当社の氏名",
      ReAssignEmailAddLabel: "電子メールアドレス",
      ReAssignLicenseCurrentLabel: "セールスセンターのアクセス権（現在）",
      ReAssignLicenseRequestedLabel:
        "セールスセンターのアクセス権（リクエスト）",
      ReAssignCancelBtnLabel: null,
      ReAssignConfirmBtnLabel: null,
      ConsolePartnerInvalidPageSize:
        "有効なページサイズを入力してください。（1-99）",

      //new trans
      go_to_home_page: "ホームページに戻る",

      //combining 2 words
      page_heading_other: "プロフィールを編集",
      page_heading_prim: "プロフィールを編集",

      // not there
      msg_reassign_popup: "One Primary and one Secondary contact required",
      profile_info: "Profile Information",

      ReAssignPrimaryContactExceedErrMsg:
        "Only one Primary Contact is allowed.",
      ReAssignSecondaryContactExceedErrMsg:
        "Only one Secondary Contact is allowed.",
      ReAssignPrimaryContactRequiredErrMsg: "A Primary Contact is required.",
      ReAssignSecondaryContactRequiredErrMsg:
        "A Secondary Contact is required.",
    },
  },
  ko_KR: {
    managePartnership: {
      PP_APC_Header_Label: null,
      OnbrdContactPrefLang: "기본 언어 *",
      PP_Adobe_Portal: null,
      ConsolePartnerHeader: "파트너십 콘솔",
      OnbrdGenReturnToPartnerHome: "파트너 홈 페이지로 돌아가기",
      ConsolePartnerContactInfoHeader: "담당자 정보",
      ConsolePartnerAccountCompName: "회사 이름",
      ConsolePartnerConMainType: "주요 담당자 유형",
      OnbrdContactPrimaryType: "기본",
      OnbrdContactSecondaryType: "추가",
      OnbrdContactOtherType: "기타",
      ConsolePartnerConActive: "활성",
      ConsolePartnerConPrefix: "경칭",
      ConsolePartnerConSuffix: "호칭/칭호",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      ConsolePartnerConFName: "이름",
      ConsolePartnerConLName: "성",
      ConsolePartnerConPhone: "전화 *",
      ConsolePartnerConRole: "직무 *",
      ConsolePartnerConEmail: "이메일 *",
      ConsolePartnerConLang: "기본 언어 *",
      ConsolePartnerContactAddRole: "추가 역할 *",
      ConsolePartnerContactCert: "인증",
      ConsolePartnerBtnEdit: "수정",
      OnbrdContactPriConHeader: "기본 담당자",
      OnbrdContactSecConHeader: "추가 담당자",
      OnbrdContactOther: "다른 담당자",
      OnbrdContactPrefix: "경칭",
      OnbrdContactTitle: "호칭/칭호",
      OnbrdContactFName: "이름 *",
      OnbrdGenInputErrorMsg: "값을 입력하십시오.",
      OnbrdContactLName: "성 *",
      OnbrdContactPhone: "전화 *",
      OnbrdContactJRole: "직무 *",
      OnbrdContactEmail: "이메일 *",
      ConsolePartnerContactCType: "주요 담당자 유형 *",
      OnbrdContactDeactivateHelp:
        "비활성화 상자에 체크 표시를 하면 계정에서 이 담당자가 삭제되고 이 담당자는 더 이상 Adobe 시스템에 액세스할 수 없습니다.",
      OnbrdContactAddtlType: "유형 *",
      TrngSaveClose: "저장하고 닫기",
      TrngClose: "닫기",
      OnbrdGenInvalidTokenErrMsg:
        "귀사의 링크가 이미 만료되었습니다. 헬프 데스크에 문의하십시오.",
      OnbrdGenInvalidToken: "  \n<p>잘못된 거래 토큰.</p>\n     ",
      OnbrdGenSessionExpired:
        "  세션이 종료되었습니다. 기본 담당자 재할당 버튼을 다시 클릭하십시오.     ",
      OnbrdThankYouHelpDesk:
        "지원이 필요한 경우 Adobe Partner Connection 헬프 데스크에 문의하십시오. \n <p/>\n이메일:  \n영어 지원: apacresellers@adobe.com  \n한국어 지원: koreapm@adobe.com \n \n전화번호: \n한국 수신자 부담 전화번호 080 951 0880 \n아시아 태평양 지역(영어 지원) +65 66221458",
      ConsolePartnerBtnEditProfile: "프로필 수정",
      ConsolePartnerRegistrationHeader: "등록 정보",
      ConsolePartnerMembershipId: "멤버십 ID",
      ConsolePartnerParentMemId: "상위 멤버십 ID",
      ConsolePartnerAccountStartDate: "계약 시작일",
      ConsolePartnerAccountLevel: "파트너 등급",
      ConsolePartnerAccountEndDate: "계약 종료일",
      ConsolePartnerAccountSpec: "전문 파트너",
      ConsolePartnerAccountManager: "계정 관리자",
      ConsolePartnerAccountLicReq: "추가 액세스 권한 수",
      ConsolePartnerAccountHeader: "계정 프로필",
      ConsolePartnerAccountCType: "회사 유형",
      ConsolePartnerAccountTradingName: "거래 이름",
      ConsolePartnerAccountRegNum: "등록 번호",
      ConsolePartnerAccountYOI: "설립 연도 *",
      ConsolePartnerAccountEmail: "이메일 도메인",
      ConsolePartnerAccountStreet: "주소 *",
      ConsolePartnerAccountPhone: "기본 전화 *",
      ConsolePartnerAccountCity: "구/군/시 *",
      ConsolePartnerAccountFax: "기본 팩스",
      ConsolePartnerAccountState: "시/도 *",
      ConsolePartnerAccountEmailAdd: "이메일 주소 *",
      ConsolePartnerAccountCountry: "국가 *",
      ConsolePartnerAccountWeb: "웹 사이트 *",
      ConsolePartnerAccountPostal: "우편 번호 *",
      ConsolePartnerAccountWeb2: "추가 웹 사이트",
      OnbrdProfilePreferredDistributor: "선호 총판(영어)",
      ConsolePartnerListPFinder: null,
      ConsolePartnerAccountBRN: "사업자 등록번호",
      OnbrdGenEmailFormatErrMsg: "잘못된 이메일 포맷.",
      OnbrdGenCorpEmailMsg: "기업 이메일 필요.",
      ConsolePartnerAccountListPartnerFinder: "파트너 찾기에 등재 (?)",
      ConsolePartnerContactHeader: "담당자",
      ConsolePartnerBtnAddContact: "담당자 추가",
      ConsolePartnerReassignBtnLabel: "기본 담당자 다시 지정",
      ConsolePartnerContactAction: "동작",
      ConsolePartnerContactLName: "성",
      ConsolePartnerContactFName: "이름",
      ConsolePartnerContactJob: "직무",
      ConsolePartnerContactEmail: "이메일",
      ConsolePartnerContactStatus: "상태",
      ConsolePartnerBtnFirst: "첫 페이지",
      ConsolePartnerBtnPrev: "이전",
      ConsolePartnerBtnNext: "다음",
      ConsolePartnerBtnLast: "마지막 페이지",
      ConsolePartnerPageSize: "페이지 크기",
      ConsolePartnerConReinvite: "다시 초대",
      ConsolePartnerSplznLinkHeader: "전문화 갱신 / 적용",
      ReAssignSectionHeader: "기본 담당자 다시 지정",
      ReAssignInstructionLabel:
        "기본 담당자를 다시 지정하려면,  \n귀사의 담당자의 “담당자 유형”을 변경합니다. \n  \n담당자가 표시되어 있지 않은 경우 해당 담당자가 귀사의 계정에 가입하라는 초대에 동의하지 않은 것입니다.",
      // \n2. 필요한 경우 담당자 옆에 있는 상자에 체크 표시를 하여 Sales Centre 액세스 권한을 변경합니다. 액세스 권한은 현재 보유하고 있는 수만큼만 다른 담당자에게 할당할 수 있습니다. 따라서 \"현재 Sales Centre 액세스 권한\" 수는 \"원하는 Sales Centre 액세스 권한\" 수와 일치해야 합니다.
      ReAssignDeactivateLabel: "비활성화하시겠습니까?",
      ReAssignMainContactTypeLabel: "담당자 유형",
      ReAssignContactNameLabel: "담당자 이름",
      ReAssignEmailAddLabel: "이메일 주소",
      ReAssignLicenseCurrentLabel: "현재 Sales Centre 액세스 권한",
      ReAssignLicenseRequestedLabel: "원하는 Sales Centre 액세스 권한",
      ReAssignCancelBtnLabel: "취소",
      ReAssignConfirmBtnLabel: "확인",
      ConsolePartnerInvalidPageSize: "유효한 페이지 크기(1-99)를 입력하십시오.",

      //new trans
      go_to_home_page: "홈 페이지로 돌아가기",

      //combining 2 words
      page_heading_other: "프로필 수정",
      page_heading_prim: "프로필 수정",

      // not there
      msg_reassign_popup: "One Primary and one Secondary contact required",
      profile_info: "Profile Information",

      ReAssignPrimaryContactExceedErrMsg: "한 명의 기본 담당자가 허용됩니다.",
      ReAssignSecondaryContactExceedErrMsg: "한 명의 추가 담당자가 허용됩니다.",
      ReAssignPrimaryContactRequiredErrMsg: "기본 담당자가 있어야 합니다.",
      ReAssignSecondaryContactRequiredErrMsg: "추가 담당자가 있어야 합니다.",
    },
  },
  es_ES: {
    managePartnership: {
      PP_APC_Header_Label: null,
      OnbrdContactPrefLang: "Idioma preferido *",
      PP_Adobe_Portal: null,
      ConsolePartnerHeader: "Consola de sociedad",
      OnbrdGenReturnToPartnerHome: "Volver a la página de inicio de socios",
      ConsolePartnerContactInfoHeader: "Datos de contacto",
      ConsolePartnerAccountCompName: "Nombre de la Empresa",
      ConsolePartnerConMainType: "Tipo de contacto principal",
      OnbrdContactPrimaryType: "Principal",
      OnbrdContactSecondaryType: "Secundario",
      OnbrdContactOtherType: "Otros",
      ConsolePartnerConActive: "Activo",
      ConsolePartnerConPrefix: "Título (antepuesto al nombre)",
      ConsolePartnerConSuffix: "Título (pospuesto al nombre)/puesto de trabajo",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      ConsolePartnerConFName: "Nombre",
      ConsolePartnerConLName: "Apellido",
      ConsolePartnerConPhone: "Teléfono *",
      ConsolePartnerConRole: "Funciones del puesto *",
      ConsolePartnerConEmail: "Correo electrónico *",
      ConsolePartnerConLang: "Idioma preferido *",
      ConsolePartnerContactAddRole: "Función adicional *",
      ConsolePartnerContactCert: "Certificaciones",
      ConsolePartnerBtnEdit: "Editar",
      OnbrdContactPriConHeader: "Contacto Principal",
      OnbrdContactSecConHeader: "Contacto secundario",
      OnbrdContactOther: "Otros contactos",
      OnbrdContactPrefix: "Título (antepuesto al nombre)",
      OnbrdContactTitle: "Título (pospuesto al nombre)/puesto de trabajo",
      OnbrdContactFName: "Nombre *",
      OnbrdGenInputErrorMsg: "Introduzca un valor.",
      OnbrdContactLName: "Apellido *",
      OnbrdContactPhone: "Teléfono *",
      OnbrdContactJRole: "Funciones del puesto *",
      OnbrdContactEmail: "Correo electrónico *",
      ConsolePartnerContactCType: "Tipo de contacto principal *",
      OnbrdContactDeactivateHelp:
        "Al marcar la casilla de desactivación, se eliminará el contacto de la cuenta. Este contacto dejará de tener acceso a los sistemas de Adobe.",
      OnbrdContactAddtlType: "Tipo *",
      TrngSaveClose: "Guardar y cerrar",
      TrngClose: "Cerrar",
      OnbrdGenInvalidTokenErrMsg:
        "Su enlace ya ha caducado. Póngase en contacto con el servicio de asistencia.",
      OnbrdGenInvalidToken: "  \n<p>Token de transacción no válido.</p>\n     ",
      OnbrdGenSessionExpired: null,
      OnbrdThankYouHelpDesk:
        "<strong>Si tiene cualquier pregunta sobre el Adobe Partner Connection Reseller Program, póngase en contacto con el servicio de asistencia Adobe Partner Connection Help Desk:</strong> \nEmail [todos los países de la región EMEA (Europa, Oriente Medio y África)]: euroresellers@adobe.com \nTeléfono [todos los países de la región EMEA (Europa, Oriente Medio y África)]: +44 (0)20 7365 0734 \n   ",
      ConsolePartnerBtnEditProfile: "Editar perfil",
      ConsolePartnerRegistrationHeader: "Información de registro",
      ConsolePartnerMembershipId: "Actualizar ID de miembro de cuenta",
      ConsolePartnerParentMemId: "ID de la Inscripción Principal",
      ConsolePartnerAccountStartDate: "Fecha de inicio de contrato",
      ConsolePartnerAccountLevel: "Nivel de socio",
      ConsolePartnerAccountEndDate: "Fecha de finalización de contrato",
      ConsolePartnerAccountSpec: "Datos de especialista",
      ConsolePartnerAccountManager: "Administrador de cuentas",
      ConsolePartnerAccountLicReq: "# Licencias adicionales",
      ConsolePartnerAccountHeader: "Perfil de cuenta",
      ConsolePartnerAccountCType: "Tipo de empresa",
      ConsolePartnerAccountTradingName: "Nombre comercial",
      ConsolePartnerAccountRegNum: "Número de registro",
      ConsolePartnerAccountYOI: "Año de incorporación *",
      ConsolePartnerAccountEmail: "Dominio de correo electrónico",
      ConsolePartnerAccountStreet: "Calle *",
      ConsolePartnerAccountPhone: "Teléfono principal *",
      ConsolePartnerAccountCity: "Ciudad *",
      ConsolePartnerAccountFax: "Fax",
      ConsolePartnerAccountState: "Estado/Provincia *",
      ConsolePartnerAccountEmailAdd: "Correo electrónico *",
      ConsolePartnerAccountCountry: "País *",
      ConsolePartnerAccountWeb: "Sitio web *",
      ConsolePartnerAccountPostal: "Código postal *",
      ConsolePartnerAccountWeb2: "Sitio web secundario",
      OnbrdProfilePreferredDistributor: "Mayorista Preferido",
      ConsolePartnerListPFinder: null,
      ConsolePartnerAccountBRN: "Número de registro de empresa",
      OnbrdGenEmailFormatErrMsg: "Formato de correo electrónico no válido.",
      OnbrdGenCorpEmailMsg: "Correo electrónico corporativo obligatorio.",
      ConsolePartnerAccountListPartnerFinder:
        "¿Desea que se le añada a la lista del buscador de revendedores?",
      ConsolePartnerContactHeader: "Contactos",
      ConsolePartnerBtnAddContact: "Agregar contacto",
      ConsolePartnerReassignBtnLabel: "Reasignar contacto principal",
      ConsolePartnerContactAction: "Acción",
      ConsolePartnerContactLName: "Apellido",
      ConsolePartnerContactFName: "Nombre",
      ConsolePartnerContactJob: "Funciones del puesto",
      ConsolePartnerContactEmail: "Correo electrónico",
      ConsolePartnerContactStatus: "Estado",
      ConsolePartnerBtnFirst: "Primera página",
      ConsolePartnerBtnPrev: "Anterior",
      ConsolePartnerBtnNext: "Siguiente",
      ConsolePartnerBtnLast: "Última página",
      ConsolePartnerPageSize: "Tamaño de página",
      ConsolePartnerConReinvite: "Volver a invitar",
      ConsolePartnerSplznLinkHeader: "Aplicar / Renovar Especialización",
      ReAssignSectionHeader: "Reasignación de contacto principal",
      ReAssignInstructionLabel:
        "Para reasignar el contacto principal: \n \n  \nSi un contacto no aparece en la lista se debe a que no ha aceptado la invitación para unirse a su cuenta.",
      //Cambie el tipo de contacto para sus contactos.  \n2. Cambie el acceso al Sales Centre haciendo clic en la casilla de verificación situada junto a cada contacto. Únicamente puede asignar acceso al mismo número de contactos que actualmente tienen acceso. Por ello, el número de contactos con la marca “Acceso actual al Sales Centre” debe ser igual al número de contactos con “Acceso deseado al Sales Centre”.
      ReAssignDeactivateLabel: "¿Desea desactivarlo?",
      ReAssignMainContactTypeLabel: "Tipo de contacto",
      ReAssignContactNameLabel: "Nombre de contacto",
      ReAssignEmailAddLabel: "Dirección de correo electrónico",
      ReAssignLicenseCurrentLabel: "Acceso al Sales Centre actual",
      ReAssignLicenseRequestedLabel: "Acceso deseado al Sales Centre",
      ReAssignCancelBtnLabel: "Cancelar",
      ReAssignConfirmBtnLabel: "Confirmar",
      ConsolePartnerInvalidPageSize:
        "Introduzca un tamaño de página válido (1-99).",

      //new trans
      go_to_home_page: "Volver a la página de inicio",

      //combining 2 words
      page_heading_other: "EDITAR PERFIL",
      page_heading_prim: "EDITAR PERFIL",

      // not there
      msg_reassign_popup: "One Primary and one Secondary contact required",
      profile_info: "Profile Information",

      ReAssignPrimaryContactExceedErrMsg:
        "Solamente se permite un contacto principal.",
      ReAssignSecondaryContactExceedErrMsg:
        "Solamente se permite un contacto secundario.",
      ReAssignPrimaryContactRequiredErrMsg:
        "Se requiere un contacto principal.",
      ReAssignSecondaryContactRequiredErrMsg:
        "Se requiere un contacto secundario.",
    },
  },
  fr_FR: {
    managePartnership: {
      PP_APC_Header_Label: null,
      OnbrdContactPrefLang: "Langue choisie *",
      PP_Adobe_Portal: null,
      ConsolePartnerHeader: "Console de partenariat",
      OnbrdGenReturnToPartnerHome:
        "Retour à la page d'accueil du portail Partenaires",
      ConsolePartnerContactInfoHeader: "Contacts",
      ConsolePartnerAccountCompName: "Nom complet de la société",
      ConsolePartnerConMainType: "Type du contact principal",
      OnbrdContactPrimaryType: "Principal",
      OnbrdContactSecondaryType: "Second",
      OnbrdContactOtherType: "Autres",
      ConsolePartnerConActive: "Actif",
      ConsolePartnerConPrefix: "Préfixe",
      ConsolePartnerConSuffix: "Suffixe/Titre",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      ConsolePartnerConFName: "Prénom",
      ConsolePartnerConLName: "Nom",
      ConsolePartnerConPhone: "Téléphone *",
      ConsolePartnerConRole: "Fonction *",
      ConsolePartnerConEmail: "E-mail *",
      ConsolePartnerConLang: "Langue choisie *",
      ConsolePartnerContactAddRole: "Rôle supplémentaire *",
      ConsolePartnerContactCert: "Certifications",
      ConsolePartnerBtnEdit: "Modifier",
      OnbrdContactPriConHeader: "Contact Principal",
      OnbrdContactSecConHeader: "Contact Secondaire",
      OnbrdContactOther: "Autres contacts",
      OnbrdContactPrefix: "Préfixe",
      OnbrdContactTitle: "Suffixe/Titre",
      OnbrdContactFName: "Prénom *",
      OnbrdGenInputErrorMsg: "Veuillez indiquer une valeur.",
      OnbrdContactLName: "Nom *",
      OnbrdContactPhone: "Téléphone",
      OnbrdContactJRole: "Fonction *",
      OnbrdContactEmail: "E-mail *",
      ConsolePartnerContactCType: "Type du contact principal *",
      OnbrdContactDeactivateHelp:
        "L'activation de la case à cocher DÉSACTIVER supprimera le contact du compte et l'empêchera d'accéder aux systèmes Adobe.",
      OnbrdContactAddtlType: "Type *",
      TrngSaveClose: "Enregistrer et fermer",
      TrngClose: "Fermer",
      OnbrdGenInvalidTokenErrMsg:
        "Votre lien a déjà expiré. Contactez le service d'assistance.",
      OnbrdGenInvalidToken: "  \n<p>Jeton de transaction incorrect.</p>\n     ",
      OnbrdGenSessionExpired: null,
      OnbrdThankYouHelpDesk:
        "<strong>Pour toute question sur Reseller Program ou votre candidature, contactez le service Adobe Partner Connection Help Desk:</strong> \nEmail (tous les pays de la zone EMEA): euroresellers@adobe.com \nTéléphone (tous les pays de la zone EMEA): +44 (0)20 7365 0734 \nNuméro sans frais pour la France: 0805 540 199    ",
      ConsolePartnerBtnEditProfile: "Modifier le profil",
      ConsolePartnerRegistrationHeader: "Données d'inscription",
      ConsolePartnerMembershipId: "Actualiser le n° d'adhérent du compte",
      ConsolePartnerParentMemId: "Numéro de l'adhérent parent",
      ConsolePartnerAccountStartDate: "Date de début de contrat",
      ConsolePartnerAccountLevel: "Niveau de partenariat",
      ConsolePartnerAccountEndDate: "Date de fin de contrat",
      ConsolePartnerAccountSpec: "Informations sur le spécialiste",
      ConsolePartnerAccountManager: "Responsable des comptes",
      ConsolePartnerAccountLicReq: "Nombre de licences supplémentaires",
      ConsolePartnerAccountHeader: "Profil du compte",
      ConsolePartnerAccountCType: "Type de société",
      ConsolePartnerAccountTradingName: "Raison commerciale",
      ConsolePartnerAccountRegNum: "Matricule",
      ConsolePartnerAccountYOI: "Année de constitution de la société *",
      ConsolePartnerAccountEmail: "Extension d’email",
      ConsolePartnerAccountStreet: "Rue *",
      ConsolePartnerAccountPhone: "Num.Téléphone Principal *",
      ConsolePartnerAccountCity: "Ville *",
      ConsolePartnerAccountFax: "Num.Fax Principal",
      ConsolePartnerAccountState: "État/Province *",
      ConsolePartnerAccountEmailAdd: "E-mail *",
      ConsolePartnerAccountCountry: "Pays *",
      ConsolePartnerAccountWeb: "Site web *",
      ConsolePartnerAccountPostal: "Code postal *",
      ConsolePartnerAccountWeb2: "Site web secondaire",
      OnbrdProfilePreferredDistributor: "Distributeur favori",
      ConsolePartnerListPFinder: null,
      ConsolePartnerAccountBRN: "Matricule de la société",
      OnbrdGenEmailFormatErrMsg: "Format de courrier électronique incorrect",
      OnbrdGenCorpEmailMsg: "L'adresse électronique de la société est requise.",
      ConsolePartnerAccountListPartnerFinder:
        "Figurer dans l'annuaire des revendeurs (?)",
      ConsolePartnerContactHeader: "Contacts",
      ConsolePartnerBtnAddContact: "Ajouter un contact",
      ConsolePartnerReassignBtnLabel: "Re-attribuer contact principal",
      ConsolePartnerContactAction: "Action",
      ConsolePartnerContactLName: "Nom",
      ConsolePartnerContactFName: "Prénom",
      ConsolePartnerContactJob: "Fonction",
      ConsolePartnerContactEmail: "E-mail",
      ConsolePartnerContactStatus: "Statut",
      ConsolePartnerBtnFirst: "Première page",
      ConsolePartnerBtnPrev: "Précédent",
      ConsolePartnerBtnNext: "Suivant",
      ConsolePartnerBtnLast: "Dernière page",
      ConsolePartnerPageSize: "Nombre de pages",
      ConsolePartnerConReinvite: "Ré-inviter",
      ConsolePartnerSplznLinkHeader: "Appliquer / Renouveler Spécialisation",
      ReAssignSectionHeader: "Changer de contact principal",
      ReAssignInstructionLabel:
        "Pour changer de contact principal : \n Modifiez le type de vos contacts. \n  \nS'il manque un contact dans la liste, cela signifie qu'il n'a pas accepté l'invitation à rejoindre votre compte.",
      // \n2. Pour modifier l'accès d'un contact au Sales Centre, activez la case à cocher de ce contact. Vous ne pouvez pas modifier le nombre de contacts ayant accès au Sales Centre. Par conséquent, le nombre de contacts dont la case à cocher « Accès en cours au Sales Centre » est activée doit être égal au nombre de contacts dont la case à cocher « Accès au Sales Centre souhaité » est activée.
      ReAssignDeactivateLabel: "Désactiver ?",
      ReAssignMainContactTypeLabel: "Type de contact",
      ReAssignContactNameLabel: "Nom du contact",
      ReAssignEmailAddLabel: "Adresse électronique",
      ReAssignLicenseCurrentLabel: "Accès en cours au Sales Centre",
      ReAssignLicenseRequestedLabel: "Accès au Sales Centre souhaité",
      ReAssignCancelBtnLabel: "Annuler",
      ReAssignConfirmBtnLabel: "Confirmer",
      ConsolePartnerInvalidPageSize:
        "Saisissez un nombre de pages correct (1-99).",

      //new trans
      go_to_home_page: "Revenir à la page d'accueil",

      //combining 2 words
      page_heading_other: "MODIFIER LE PROFIL",
      page_heading_prim: "MODIFIER LE PROFIL",

      // not there
      msg_reassign_popup: "One Primary and one Secondary contact required",
      profile_info: "Profile Information",

      ReAssignPrimaryContactExceedErrMsg:
        "Un seul contact principal est autorisé.",
      ReAssignSecondaryContactExceedErrMsg:
        "Un seul contact secondaire est autorisé.",
      ReAssignPrimaryContactRequiredErrMsg: "Un contact principal est requis.",
      ReAssignSecondaryContactRequiredErrMsg:
        "Un contact secondaire est requis.",
    },
  },
  es_LA: {},
};

export default managePartnershipTranslation;
